// extracted by mini-css-extract-plugin
export var active = "_kq-2";
export var recordingDot = "_kq-1";
export var recordingIndicator = "_kq-0";